import React from 'react';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

import { useDispatch } from 'react-redux';
import { fetchEventPayments } from '../../../../redux/actions/payment';
import API from '../../../../services/api';

export const RemoveDiscountCodeButton = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await API.delete(`/api/discountCodes/${id}`);
      dispatch(fetchEventPayments());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <IconButton disabled>
        <DeleteIcon color="disabled" />
      </IconButton>
    );
  }
  return (
    <IconButton onClick={() => handleDelete(id)}>
      <DeleteIcon color="secondary" />
    </IconButton>
  );
};
